import { useEffect } from 'react';
import { useCardOperations } from './useCardOperations';

export const useInitActiveCards = () => {
  const { getActiveCards } = useCardOperations();

  useEffect(() => {
    getActiveCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
